import axios from 'axios'

axios.defaults.baseURL = process.env.REACT_APP_API_URL
//axios.defaults.baseURL = "http://10.0.2.2:3001"
axios.interceptors.request.use(
  async requestConfig => {
    //console.log("-------URL")
    //console.log(axios.defaults.baseURL)
    return requestConfig
  },
  error => {
    //console.log("-------error")
    //console.log(error)
    return Promise.reject(error)
  }
)

export { axios }
